//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DetailLicence.ts						</Name>
//    <Description> Dialog detailu licence										</Description>
//    <Author>      thazmuka													</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019							</Copyright>
//    <Created>     2018-02-21													</Created>
//  </FileHeader>

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

    /** inteface - Response služeb pro Detail Stupen Schvaleni Epk */
    export interface IDetailGrafDefiniceResponse {
        /** data výstupu */
        data: Gordic.AdmIsl.Interface.GGrafDefiniceDto,
        result: {
            /** data výstupu */
            data: Gordic.AdmIsl.Interface.GGrafDefiniceDto,
            /** chyby */
            errors: {
                /** zpráva chyby */
                message: string
            }[],
            /** typ výstupu operace */
            kind: Adm.Utils.GOperationResultKind
        }
    }

	//#endregion

	/** Dialog detailu  */
	@gcontent
    export class DetailGrafDefinice extends GContentBase {

		//#region attributes

        /** příznak, že se jedná o nový záznam */
        private newRecord: boolean;
        /** Příznak, že okno se nachází v editačním režimu */
        private editMode: boolean;

		/** PK - ixs_grf */
        private ixs_grf: string | null;

        /** data detailu */
        private data: Gordic.AdmIsl.Interface.GGrafDefiniceDto;
		/*** element panelu v sidebaru */
		private panelElement: JQuery<HTMLElement>
		private panelId: string;
		/** elmenet sidebaru */
		private sidebar: JQuery<HTMLElement>;
		/** příznak přímého přístupu na detail */
		private detailCommand: boolean

		//#endregion


        /** onContentReady */
        public onContentReady() {
            this.init();
        }

        public closing() {

            var dfd = $.Deferred();

            if (this.closeContent === false) {
                //RC 32000132 : Pozor
                //RC 32000133 : Nelze odejít! Probíhá generování grafů.
                this.dialogs.alert("jres:32000132!", "jres:32000133");
                return dfd.reject();
            }
            else {
                // jedná se o editační mód, nelze odejít z detailu
                if ((this.editMode === true) && this.newRecord === false) {
                    alert("jres:32000126"); //RC 32000126 : Na okně jsou rozeditovaná data, uložte je nebo zrušte.
                    return dfd.reject();
                }
                else {
                    return dfd.resolve();
                }
            }
            
        }

		//#region ready & init

        /** refreshDetail content */
        private refreshDetail(): void {

            this.HideAllFlash(); 
			this.load();
		}

        /** Načtení dat ze serveru na následné nastavení na detail okně */
        private loadData() {

            this.HideAllFlash(); 
            var fragments: string[] = [Utils.GAdmIslConst.detail];

            if (this.newRecord) {
                fragments.push(Utils.GAdmIslConst.defaultValuesForNewRecord);
            }

            var readResult: any = this.isl.GrafDefinice.read({
                data: { ixs_grf: this.ixs_grf },
                fragments: fragments
            } ).get();

            // SUCCESS
            readResult.done((output: IDetailGrafDefiniceResponse) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.data = output.data;
                    this.element.findFields().gfield("model", "apply", this.data);
                    if (this.newRecord) 
                        this.setEditMode(true);       // při NEW je okno ihned přepnuto do edit režimu - musí být před setMenuButtons()
                    this.setMenuButtons(this.editMode);
                    this.createSidebar();
                } else {
                    var errors = output.result.errors;
                    for (var index = 0; index < errors.length; index++) {
                        var error = errors[index];
                        this.ShowLoadError(error.message, index);
                    }
                }
            });
            // ERROR
            readResult.fail((err) => {
                console.error("Chyba načtení! " + err );
                this.ShowLoadError("jres:32131045!");
            });   
        } // loadData

		//#endregion

        /** Uložení dat formuláře do databáze */
        private saveData(nova_data: Gordic.AdmIsl.Interface.GGrafDefiniceDto): void {
            this.HideAllFlash(); 
            this.ShowSaveError("jres:32131093");   //RC 32131093 : Tento typ záznamu nelze zakládat ani editovat.
        }

		/** init content */
        private init() {

			// lezu na detail ze seznamu a ne pomocí linku
			if (this.detailCommand === false) {
				var GinListControlsObject = (Gin.DetailBuilderComponents as any).GinListControls.create(this);
				this.actions.addRange(GinListControlsObject.actions);
                this.createStatusBar(GinListControlsObject.menubar);
				$.extend(this, GinListControlsObject.contentExtensions);
			}

			this.setTitle();
			this.createMenuBar();
			this.createForm();
			this.createCommandBar();

            // lezu na detail ze seznamu a ne pomocí linku
			if (this.detailCommand === false) {
				// vytvořit šipky na procházení detailu
                (this as any).listControls_setup({
                    //gridRemoteControl: this.gridRemoteControl,
					//funkce, která řádek z gridu přetransformuje v dto pro zavolání this.load(dto); Může vracet promise.
					rowToDto: function (gridState) {
						return {
                            stav_schvproc: gridState.currentRow.data.stav_schvproc
						};
					},
					//template pro tooltip na šipce následující
                    nextItemTemplate: "jres:33000155: {stav_schvproc}",
					//template pro tooltip na šipce předchozí
                    prevItemTemplate: "jres:33000156: {stav_schvproc}"
				});
				(this as any).listControls_updateCaptions();
            }
		}

		/** vytvořit statusbar */
		private createStatusBar(GinListControlsObject?: any) {
			const bar: MenuParams[] = [];
			if (GinListControlsObject !== undefined) {
				bar.push.apply(bar, GinListControlsObject);
			}
			this.statusBar(bar);
		}


        /** Skrytí všech flash */
        private HideAllFlash() {
            // skryji případné Flash panely - musím začít s čistým štítem
            this.hideFlash("idSaveSuccess");    
            this.hideFlash("idSaveError");  
            this.hideFlash("idLoadError");
            for (var index = 0; index < 10; index++) {
                this.hideFlash("idSaveError" + index);
                this.hideFlash("idLoadError" + index);
            }
        }
        /** Zobrazí příznaku úspěšného uložení */
        private ShowSaveSuccess() {
            this.showFlash("jres:32000123", "g-state-success", 2000, "idSaveSuccess"); //RC 32000123 : Detail byl úspěšně uložen
        }
        /** Zobrazí příznaku chyby při uložení dat */
        private ShowSaveError(text: string, index?: number) {
            if (index === undefined)
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idSaveError" ); //RC 32000124 : Chyba
            else
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idSaveError" + index); //RC 32000124 : Chyba
        }
        /** Zobrazí příznaku chyby při načtení dat */
        private ShowLoadError(text: string, index?: number) {
            if (index === undefined)
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idLoadError"); //RC 32000124 : Chyba
            else
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idLoadError" + index); //RC 32000124 : Chyba
        }

        

		//#region title

		/** nastavit titulek dialogu */
		private setTitle() {

            var title = "";

            if (this.newRecord === false) {
                title = "jres:32131033 " + this.ixs_grf 	//RC 32131033 : Detail
            }
            else {
                title = "jres:32000121" //RC 32000121 : Nový záznam
            }

            this.title = title;

		}


		//#endregion

		//#region form

		/** vytvořit formulář a načtení dat ze serveru */
        private createForm() {

            var form = $("<div>").appendTo(this.element);

            var Form = new Gordic.Forms.Form({							// odstranit any, az bude .d.ts k filefield policku
                name: "FormGrafDefiniceService",
                layoutDescriptor: "L2M2S1, L-2-6-4, M-4-8-0, S-12-12-0",
            });

            Form
                .addSection("jres:32131091") //RC 32131091 : Graf

            Form
                .addRow({
                    label: "jres:32131027"  //RC 32131027 : ID
                })
                .addField("gstringbox", {
                    name: "ixs_grf",
                    customClass: "w-6",
                    disabled: !this.newRecord
                })
                .addRow({
                    label: "jres:32131029" // LIC, ICO //RC 32131029 : Název
                })
                .addField("gstringbox", {
                    name: "nazev",
                    customClass: "w-12",
                    disabled: !this.newRecord
                })

                .addRow({
                    label: "jres:32131115"  //RC 32131115 : Popis grafu 1
                })
                .addField("gstringbox", {
                    name: "popis_grf1",
                    customClass: "w-12",
                    disabled: !this.newRecord
                })

                .addRow({
                    label: "jres:32131116"  //RC 32131116 : Popis grafu 2
                })
                .addField("gstringbox", {
                    name: "popis_grf2",
                    customClass: "w-12",
                    disabled: !this.newRecord
                })


                .addRow({
                    label: "jres:32131117"  //RC 32131117 : Popis výskytů
                })
                .addField("gstringbox", {
                    name: "popis_count",
                    customClass: "w-12",
                    disabled: !this.newRecord
                })

                .addRow({
                    label: "jres:32131118"  //RC 32131118 : Popis součtů
                })
                .addField("gstringbox", {
                    name: "popis_sum",
                    customClass: "w-12",
                    disabled: !this.newRecord
                })

                // meritko_count - pokud je 0, potom tento graf není
                // meritko_sum - pokud je 0, potom tento graf není

                .addRow({
                    label: "jres:32131055" //RC 32131055 : Datum OD
                })
                .addField("gdatebox", {
                    disabled: true,
                    name: "dat_od",
                    valueType: "date"
                })
                .addRow({
                    label: "jres:32131056" //RC 32131056 : Datum DO
                })
                .addField("gdatebox", {
                    disabled: true,
                    name: "dat_do",
                    valueType: "date"
                })

                .addRow({
                    label: "jres:32131030" //RC 32131030 : Aktivita
                })
                .addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {  
                    disabled: !this.newRecord,
                    dropdown: true,                                                                 // políčko jako combobox
                    name: "aktivita",                                                            // název položky
                    model: "model.aktivita=value.aktivita",                                       // model je to, co je na teto strance , value je to, co je v políčku
                })
                .addRow({
                    label: "jres:32131031" //RC 32131031 : Změnil
                })


                .addField("gselectbox", Gordic.Prefabs.Select.ginszmp(), {
                    disabled: true,
                    dropdown: true,                                                                 // políčko jako combobox
                    name: "ixs_zmp",                                                            // název položky
                    model: "model.zmenu_prov=value.ixs_zmp"                                       // model je to, co je na teto strance , value je to, co je v políčku
                })
                .addRow({
                    label: "jres:32131032" //RC 32131032 : Změněno
                })
                .addField("gdatebox", {
                    disabled: true,
                    name: "dat_zmena",
                    valueType: "datetime"
                }) 
                
            

			form.gform("createFrom", Form);

            this.loadData();            // ze serveru se načtou data a to i pro případ this.newRecord - v tom případě se čtou aspoň default value a permissions

            // Vytvoření funkce pro přechod na editační režim v rámci dvojkliku na libovolném políčku formuláře
            form.findFields().dblclick(() => {
                if (this.newRecord === false && Utils.getCanEdit(this.data.Permissions)) {
                    this.setEditMode(true);
                    this.setMenuButtons(true);
                }
            });


		}

		//#endregion

		//#region menubar

        /** zavřít content? */
        private closeContent = true;

		/** vytvořit menubar */
		private createMenuBar() {

            const menuBar: MenuParams[] = [];
            /** id operace */
            var idOperation = "operationGenerateGraphs";

            // REFRESH
            menuBar.push({
                favorite: true,
                action: this.actions.add(new GAction({
                    icon: "fa-repeat",
                    name: "actGenerateGraphs",
                    caption: "jres:32000135",			//RC 32000135 : Generovat grafy
                    run: () => {

                        var obj: IGClientProgressOptions = {
                            id: idOperation,
                            text: "jres:32000134", //RC 32000134 : Probíhá generování grafů
                        };

                        this.closeContent = false;
                        this.beginOperation(obj);

                        this.call("GenerateGraphs", { IxsGrf: this.ixs_grf }, {}, { progressState: false })
                            .then(() => {
                                this.endOperation(idOperation);
                                this.closeContent = true;
                            })
                            .fail(() => {
                                this.closeContent = true;
                            })

                    }
                }))
            });

            // OBSAH GRAFU
            menuBar.push({
                align: "opposite",
                favorite: true,
                action: this.actions.add(new GAction({
                    name: "actShowGrafObsah",
                    icon: "gi-list",
                    caption: "jres:32131096",			//RC 32131096 : Data grafu
                    run: () => {
                        Dialogs.SeznamGrafObsahDlg(this, { ixs_grf: this.ixs_grf, data: this.data}).done((data: any) => {
                            //this.reloadDataOnGrid();		// t.hazmuka: hazel chybu sidebaru a vyhodnotil jsem, ze tu neni potreba, kdyz je refresh i v menu
                        });
                        //this.navigate('Gordic.Adt.WebControls.SeznamFunkceSchvalovaciRoleEpk', { ID: 'SeznamFunkceSchvalovaciRoleEpk#', taskId: 'actFunkceSchvalovaciRoleEpk', ixs_sro: this.ixs_sro });
                    }
                }))
            });

            // REFRESH
			menuBar.push({
				align: "opposite",
				favorite: true,
				action: this.actions.add(new GAction({
					icon: "gi-refresh",
					name: "actRefresh",
					caption: "jres:32131040",			//RC 32131040 : Občerstvení
					run: () => {
						this.refreshDetail();
					}
				}))
			});

			this.menuBar(menuBar);

        }

        /** Přepnutí dostupnosti políček podle aktuálního režimu okna 
         editMode - příznak, že okno je v editačním režimu
         */
        private setEditMode(editMode: boolean) {
            // odblokování/zablokování všech políček formuláře 
            this.findFields().gfield("option", { disabled: !editMode });

            // vždy read only
            this.findFields("ixs_grf").gfield("option", { disabled: true });
            this.findFields("dat_zmena").gfield("option", { disabled: true });
            this.findFields("zmenu_prov").gfield("option", { disabled: true });

            this.editMode = editMode;
        }

        /** Přepnutí viditelnost tlačítek podle aktuálního režimu okna 
         editMode - příznak, že okno je v editačním režimu
         */
        private setMenuButtons(editMode: boolean) {
            //Utils.setActionVisible(this.actions.actEditRecord, !editMode);
            //Utils.setActionEnabled(this.actions.actEditRecord, Utils.getCanEdit(this.data.Permissions));

            //Utils.setActionVisible(this.actions.actSaveRecord, editMode);
            //Utils.setActionVisible(this.actions.actCancelSaveRecord, editMode);
        }



		//#endregion

		//#region commandbar

		/** vytvořit commandbar */
		private createCommandBar() {

			const commandBar: MenuParams[] = [];

            // CLOSE
			commandBar.push({								
				favorite: true,
				action: this.actions.add(new GAction({
					name: "actZavrit",
					icon: "gi-window-close",
					caption: "jres:32131042",				//RC 32131042 : Zavřít
					run: () => {
						this.close();
					}
				}))
			});

			this.commandBar(commandBar);

		}

		//#endregion

		//#region statusbar

		/** odstranit všechny vlastní třídy ze statusbaru */
		private removeAllCustomClassOnStatusBar() {
			var myclass = $(".statusbar-aktivita-class").find(".g-static__text");
			myclass.removeClass("statusbar-aktivita-class-green");
			myclass.removeClass("statusbar-aktivita-class-blue");
			myclass.removeClass("statusbar-aktivita-class-red");
		}

		//#endregion

		//#region sidebar

		/** vytvořit panel */
		private createPanel(): GSideBarPanelOptions {

			this.panelId = "panelNahled";

			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : Náhled
                leaf: "jres:32131038",								//RC 32131038 : Náhled
                icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel(ITypePanel.Neurceno, $(ev.target))
				},
			} as GSideBarPanelOptions;

			return panel;
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/** vytvořit sidebar */
		private createSidebar() {

			this.removeSidebar();
			var panel = this.createPanel();

			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: [panel]
				}
			});
		}

		/** občerstvení panelu v sidebaru */
		private refreshPanel(type: ITypePanel, elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;
			}

			if (panel !== undefined) {

				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}

				this.panelElement = $("<div>").appendTo(panel);

				//if (type === ITypePanel.HistorieSpusteni) {
				//	GridUtils.setPanelGrid("jres:32000055", this.row_historie_spusteni, this.gridFormatHistorieSpusteni, this.panelElement);
				//}
				//else {
					this.setPreviewEmpty();
				//}

			}

		}
        /** vytovření prázdného sidebar panelu s náhledek */
		private setPreviewEmpty(): void {
			var p7s_element = $("<div'>").addClass("Adm-p7s-class");
			p7s_element.appendTo(this.panelElement);
			p7s_element.text("jres:32131043"); //RC 32131043 : Náhled není k dispozici.
		}

		//#endregion

	}
}